export default "__VITE_ASSET__433a1ed5__"